export default {"src":"/au/_next/static/media/logo.fe5480d6.gif","height":410,"width":280,"blurWidth":0,"blurHeight":0};